import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleDoubleLeft,
    faAngleLeft,
    faAngleRight,
    faAngleDoubleRight,
    faArrowRight,
    faSortUp,
    faSortDown,
    faAsterisk,
    faBars,
    faCalendarAlt,
    faCaretDown,
    faCaretLeft,
    faCaretUp,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faClipboardCheck,
    faClock,
    faCloudUploadAlt,
    faCog,
    faDownload,
    faEdit,
    faEllipsisV,
    faEnvelope,
    faExchangeAlt,
    faExclamation,
    faExclamationTriangle,
    faEye,
    faFile,
    faFileAlt,
    faFileUpload,
    faFirstAid,
    faFolderOpen,
    faHeadset,
    faHome,
    faInfoCircle,
    faKey,
    faLock,
    faMinus,
    faMinusCircle,
    faPhone,
    faPhoneAlt,
    faPhoneSquareAlt,
    faPlus,
    faPrint,
    faQuestionCircle,
    faRedo,
    faSave,
    faSearch,
    faShare,
    faStepBackward,
    faSyncAlt,
    faTachometerAlt,
    faThLarge,
    faTicketAlt,
    faTimes,
    faTimesCircle,
    faTooth,
    faTrash,
    faTrashAlt,
    faUpload,
    faUser,
    faUsers,
    faWrench,
} from '@fortawesome/free-solid-svg-icons';

import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';

import { faComments, faPlayCircle } from '@fortawesome/free-regular-svg-icons';

library.add(
    faAngleDoubleLeft,
    faAngleLeft,
    faAngleRight,
    faAngleDoubleRight,
    faSortUp,
    faSortDown,
    faArrowRight,
    faAsterisk,
    faBars,
    faCalendarAlt,
    faCaretDown,
    faCaretLeft,
    faCaretUp,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faClipboardCheck,
    faClock,
    faCloudUploadAlt,
    faCog,
    faComments,
    faDownload,
    faEdit,
    faEllipsisV,
    faEnvelope,
    faExchangeAlt,
    faExclamation,
    faExclamationTriangle,
    faEye,
    faFacebookF,
    faFile,
    faFileAlt,
    faFileUpload,
    faFirstAid,
    faFolderOpen,
    faHeadset,
    faHome,
    faInfoCircle,
    faKey,
    faLock,
    faMinus,
    faMinusCircle,
    faPhone,
    faPhoneAlt,
    faPhoneSquareAlt,
    faPlayCircle,
    faPlus,
    faPrint,
    faQuestionCircle,
    faRedo,
    faSave,
    faSearch,
    faShare,
    faStepBackward,
    faSyncAlt,
    faTachometerAlt,
    faThLarge,
    faTicketAlt,
    faTimes,
    faTimesCircle,
    faTooth,
    faTrash,
    faTrashAlt,
    faTwitter,
    faUpload,
    faUser,
    faUsers,
    faWrench,
);